import { DeterminationForm } from "@/components/determinations/DeterminationForm"
import { createFileRoute } from "@tanstack/react-router"
import * as z from "zod"

const searchSchema = z.object({
  observationId: z.string(),
})

export const Route = createFileRoute(
  "/_private/projects/$id/collections/$collectionId/determinations/new",
)({
  component: NewDetermination,
  validateSearch: (search) => searchSchema.parse(search),
})

function NewDetermination() {
  const { id: projectId, collectionId } = Route.useParams()
  const { observationId } = Route.useSearch()

  return (
    <DeterminationForm
      projectId={projectId}
      collectionId={collectionId}
      observationId={observationId}
    />
  )
}
